import { Box, Button, Grid, Typography } from "@mui/material";
import { SubscriptionContext } from "contexts/Subscription";
import { useContext } from "react";
import { AddOnItemName, UpgradeDialogSource } from "schemas/dashboard";
import { Plans } from "schemas/payments";

import { useSubscription } from "utils/useSubscription";

const PromoAnnualBanner = () => {
  const { subscription } = useContext(SubscriptionContext);
  const isAlreadyOnAnnual =
    subscription?.isSubscribed &&
    [Plans.VA_YEARLY, Plans.PRO_YEARLY]?.includes(
      subscription?.subscription?.planName as Plans,
    );
  const { setUpgradeDialogSource } = useContext(SubscriptionContext);
  const { handleCheckoutAddOnDialog } = useSubscription();

  return isAlreadyOnAnnual ? (
    <></>
  ) : (
    <Grid
      container
      alignItems="center"
      justifyContent={"space-between"}
      gap={4}
      sx={{
        backgroundColor: "purple.light",
        borderRadius: 4,
        p: 3,
        mt: 5,
      }}
    >
      <Grid item xs={12} md={9} lg>
        <Typography
          gutterBottom
          sx={{
            fontSize: 16,

            fontWeight: 600,
          }}
        >
          🎯{" "}
          <Box component={"span"} sx={{ color: "black" }}>
            A well-crafted template can improve your response rate by{" "}
            <Box component="span" sx={{ color: "purple.dark" }}>
              +300%
            </Box>{" "}
          </Box>
        </Typography>

        <Typography sx={{ fontSize: 12 }}>
          Get a free pitch template written by our copywriters with an annual
          plan or purchase one from the Settings page.
        </Typography>
      </Grid>

      <Grid container item xs={12} md="auto" gap={2}>
        <Button
          variant="outlined"
          disableElevation
          sx={{
            px: 2,
            py: 1,
            textTransform: "none",
            color: "purple.dark",
            borderColor: "purple.dark",
          }}
          onClick={() =>
            handleCheckoutAddOnDialog(
              UpgradeDialogSource.free_template_from_templates_page,
              AddOnItemName.pitching_templates,
            )
          }
        >
          Purchase Template $30{" "}
          <Box
            component="i"
            className="fa-regular fa-arrow-right"
            sx={{ ml: 1 }}
          />
        </Button>
        <Button
          variant="contained"
          disableElevation
          sx={{
            px: 2,
            py: 1,
            textTransform: "none",
            backgroundColor: "black",
            "&:hover": {
              backgroundColor: "grey.800",
            },
          }}
          onClick={() =>
            setUpgradeDialogSource(
              UpgradeDialogSource.free_template_with_annual_plan,
            )
          }
        >
          <Typography sx={{ color: "white" }}>
            ✨ Get a <strong>Free Template</strong> with Annual Plan{" "}
          </Typography>
          <Box
            component="i"
            className="fa-regular fa-arrow-right"
            sx={{ ml: 1 }}
          />
        </Button>
      </Grid>
    </Grid>
  );
};

export default PromoAnnualBanner;
